import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2333">
      <Navbar data-id="element-2334" />
      <main data-id="element-2335">
        <ConsularAffairs data-id="element-2336" />
      </main>
      <Footer data-id="element-2337" />
      <FeedbackPopup data-id="element-2338" />
    </div>;
}